import AttToken from '../../../helpers/attToken';
import { useEffect, useState } from 'react';
import Aprovations from '../../../service/Aprovations';
import { toast } from 'react-toastify';
import queryClient from '../../../service/query';
import { ChecklistReportType } from '../../../service/Reports';
import { trackEventMatomo } from '../../../helpers/matomo';
import { useTranslation } from 'react-i18next';
import QueryFn from '../../../helpers/QueryFn';
import HeaderModal from '../../HeaderModal/HeaderModal';
import FooterModal from '../../FooterModal/FooterModal';
import { TextField } from '@mui/material';

const aprovationService = new Aprovations();
const queryFn = new QueryFn();

export default function ModalAprovation({
  openAprovation,
  setOpenAprovation,
  aprove,
  setAprove,
  checklist,
  usuarioExecutor,
  setOpenModal,
  selected,
  getAprovation
}: {
  openAprovation?: boolean,
  setOpenAprovation?: Function,
  aprove: string,
  setAprove?: Function,
  checklist: number,
  usuarioExecutor: string,
  setOpenModal?: Function,
  selected?: ChecklistReportType,
  getAprovation?: Function
}) {

  const [comment, setComment] = useState('');

  const { t } = useTranslation('translation');

  const close = () => {
    trackEventMatomo('Modal de aprovação', 'click', 'button', 'reprova');
    setOpenAprovation && setOpenAprovation(false);
    setAprove && setAprove('');
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  const submitFn = queryFn.useMutate('UPDATE_APROVATION', async () => {
    try {
      toast.warn(`${t('toast.pleaseWaitSaving')}`);
      const token = await AttToken();
      if (token) {
        const response = await aprovationService.updateAprovation(
          token,
          comment,
          aprove,
          usuarioExecutor,
          checklist,
        );
        getAprovation && getAprovation();
        queryClient.resetQueries({ queryKey: ['GET_APROVATIONS'] });
        setOpenModal && setOpenModal(false);
        toast.success(`${t('Aprovations.form')} ${aprove}`);
        return response;
      }
    } catch (err) {
      console.log(err);
    }
  });

  return (
    <div className={`modal ${openAprovation ? "modal is-active" : "modal"}`}>
      <div className="modal-background" onClick={close} onKeyDown={(e) => escape(e)}></div>
      <div className="modal-card">
        <HeaderModal headerTitle={aprove === 'aprovado' ? t('Aprovations.approve') : t('Aprovations.reject') && t('Aprovations.form')} close={close} />
        <section className="modal-card-body">
          <span style={{ fontSize: '.7em' }}>
            {t("Aprovations.attention")}<br />
            {t("Aprovations.observation")} {aprove === 'aprovado' ? t("Aprovations.aprovation") : t("Aprovations.disapproval")}.
          </span>
          <TextField
            fullWidth
            value={comment}
            onClick={() => trackEventMatomo('Modal de aprovação', 'click', 'input', 'adiciona comentário')}
            onChange={(e) => {
              setComment(e.target.value);
            }}
            className='input' placeholder={t('Aprovations.addObservation')} />
        </section>
        <FooterModal
          label={t("yes")}
          disabled={selected?.mandatory ? comment.length ? false : true : false}
          submit={() => submitFn.mutate('')}
        />
      </div>
    </div>
  );
}
